import React from "react";
import { Outlet } from "react-router-dom";
import { CContainer } from "@coreui/react";

/**
 * @function AppContent
 * @description for main content this is the main container
 * @returns JSX for content of all routes after authentication
 */

const AppContent = () => {
  return (
    <CContainer lg>
      <Outlet />
    </CContainer>
  );
};

export default React.memo(AppContent);
